import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router, UrlSegment } from '@angular/router';
import { UserDAO } from '../../../../../core/services/dao/userDAO';
import { WaterBodyDAO } from '../../../../../core/services/dao/waterBodyDAO';
import { ApiHelper } from '../../../../../core/services/apiHelper';
import { AdminAccess } from '../../../../shared/accessAdmin';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';

@Component({
  selector: 'app-water-bodies-form',
  templateUrl: './water-bodies-form.component.html',
  styleUrls: ['./water-bodies-form.component.scss'],
})
export class WaterBodiesFormComponent implements OnInit {
  public formTitle: string;

  public model: WaterBody;
  public isEditing: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userDAO: UserDAO,
    private waterBodyDAO: WaterBodyDAO,
    private apiHelper: ApiHelper,
    private checkAdmin: AdminAccess,
  ) {
    this.checkAdmin.checkAdminAccess(this.userDAO, this.apiHelper, this.router);
  }

  // todo:rmEntireComponent?
  ngOnInit() {
    // comment for test deploy
    // this.route.url
    //   .map(
    //     (urlArray: UrlSegment[]) =>
    //       urlArray.map((url: UrlSegment) => url.path).indexOf('edit') >= 0,
    //   )
    //   .subscribe((isOnEditScreen: boolean) => {
    //     this.isEditing = isOnEditScreen;
    //     this.loadThings();
    //   });
  }

  // private loadThings() {
  //   if (this.isEditing) {
  //     this.route.paramMap
  //       .switchMap((params: ParamMap) => params.getAll('id'))
  //       .subscribe(data => {
  //         this.model = this.waterBodyDAO.getById(data) as WaterBody;
  //         this.formTitle = `Edit ${this.model.name}`; //name binds due to interpolation
  //       });
  //   } else {
  //     this.model = this.waterBodyDAO.create({}) as WaterBody;
  //     this.formTitle = 'New Body of Water';
  //   }
  // }

  public cancel() {
    this.router.navigate(['manage/admin/water-bodies']);
  }

  public submit() {
    if (this.isEditing) {
      this.waterBodyDAO.serverUpdate(this.model).subscribe((result) => {
        this.router.navigate(['manage/admin/water-bodies']);
      });
    } else {
      this.waterBodyDAO.serverCreate(this.model).subscribe((result) => {
        this.router.navigate(['manage/admin/water-bodies']);
      });
    }
  }
}
